export default __webpack_public_path__ + "9229f98749c105bac072bfbf4aa57cb7.png";